import { useCallback } from 'react';
import {
  OfferEventLabels,
  OfferEventsMap,
  type TrackOfferEvent,
} from 'src/modules/analytics/useTrackAnalytics/domains/offers/events';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';

/**
 * Custom hook to handle offer analytics tracking events
 */
export function useTrackOfferAnalytics() {
  const trackEvent = useTrackEvent();
  return useCallback(
    (event: TrackOfferEvent, extra?: Record<string, unknown>) => {
      const eventLabel = OfferEventLabels[event];
      const eventInfo = OfferEventsMap[event];
      trackEvent(eventLabel, { ...eventInfo, ...extra });
    },
    [trackEvent],
  );
}
